<script>
import "@/assets/css/user-center.css"
import {
  Add,
  Edit,
  GetList,
  SaveOrderStatus,
  GetItemDetailList,
  SaveOrderFile,
  RceivingSampleLabView,
  OrderSendSampleView,
  SubmitOrderPay,
  SubmitOrderEvaluate,
  OrderRefundEdit,
  GenerateXYS,
  OrderInvoiceEdit
} from "@/api/general-api"
import OrderFiles from "@/components/OrderFiles"
import MakeInvoice from './components/MakeInvoice.vue'
import { Loading } from 'element-ui';
import Vue from "vue"

export default {
  name: 'Orders',
  data() {
    return {
      searchKeyword: '',
      activeName: '?',
      params: [],
      orders: [],
      orderStatus: [],
      currentOrder: null,
      pagination: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
        orderField: "CreateTime",
        orderType: "descend",
      },
      params: {
        applyNo: "",
        orderNo: "",
        proxyCustName: ""
      },
      checkedOrders: [],
      checkAll: false,
       fullscreenLoading: false,
    }
  },
  mounted() {
    this.GetItemDetailList(this.InitialData)
  },
  render(h) {
    return (
      <el-container class="flex-column">
        <div class="full-width flex bg-white mg-b pd-10" style="position:relative">
          <b class="desc-content">我的【检测认证】订单</b>
          <el-button style="position:absolute;right:10px;top:5px;bottom:5px" type="primary" size="mini" onClick={this.onMakeInvoiceBtnClick}>开发票</el-button>
        </div>
        <div class="full-width bg-white mg-b pd-10 no-header-underline">
          {this.renderSearchPanel()}
          {this.renderTabPanel()}
          {this.renderOrderList()}
          {this.renderPagination()}
        </div>
      </el-container>
    )
  },
  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler() {
        this.handleGetList()
      }
    }
  },
  methods: {
    onMakeInvoiceBtnClick() {
      console.log(this.checkedOrders)
      if (this.checkedOrders.length == 0) {
        return this.$message.error("请先选中订单")
      }
      this.onOpenMakeInvoiceDialog(this.checkedOrders)
    },
    onOpenMakeInvoiceDialog(orders) {
      const GirConstructor = Vue.extend(MakeInvoice);
      const nodeObj = new GirConstructor();
      nodeObj.$mount(document.createElement("div"));
      document.body.appendChild(nodeObj.$el);
      nodeObj.Options({ orders: orders });
      nodeObj.Open((shopList, close) => {
        console.log(shopList);
        let postParam = {
          data: shopList
        }
        OrderInvoiceEdit(postParam).then(res => {
          console.log(res);
          if (!res.success) {
            return this.$message.error('申请开票失败' + res.msg)
          }
          this.$message.success("申请开票成功！")
          close()
          this.handleGetList()
        })
      });
    },

    onParamsInput(key, value) {
      this.params[key] = value
      console.log(key, value)
    },
    renderSearchPanel() {
      return (
        <el-row type="flex" justify="start" align="middle" style="flex-wrap:wrap;border-bottom:1px solid #f0f0f0;padding-bottom:10px;">
          <small class="text-desc" style="margin-left:10px;">申请号过滤：</small>
          <el-col span={5}>
            <el-input placeholder="请输入申请号" size="mini"
              value={this.params.applyNo}
              on-input={(val) => this.onParamsInput('applyNo', val)}
              on-change={() => this.InitialData()}
            />
          </el-col>
          <small class="text-desc" style="margin-left:10px;">订单号过滤：</small>
          <el-col span={5}>
            <el-input placeholder="请输入订单号" size="mini"
              value={this.params.orderNo}
              on-input={(val) => this.onParamsInput('orderNo', val)}
              on-change={() => this.InitialData()} />
          </el-col>
          <small class="text-desc" style="margin-left:10px;">委托单位过滤：</small>
          <el-col span={5}>
            <el-input placeholder="请输入委托单位" size="mini"
              value={this.params.proxyCustName}
              on-input={(val) => this.onParamsInput('proxyCustName', val)}
              on-change={() => this.InitialData()} />
          </el-col>

        </el-row>
      )
    },
    /** 渲染订单类型Tab */
    renderTabPanel() {
      const { orderStatus, activeName } = this
      const renderTabLi = () => {
        return orderStatus.map((l, index) => {
          const itemKey = `${l.name}-${index}`
          const className = `a-normal-tab ${l.name === activeName ? 'active' : ''}`
          // const href = `/users/#/center/orders${l.name}`
          const url = `/users/#/center/orders${l.name}`
          return (
            <li class="nav-row-item" key={itemKey}>
              {/*<a class={className} onClick={() => this.onOrderStatusTabClick(l.name, href)}>{l.label}</a>*/}
              <a class={className} href={url}>{l.label}</a>
            </li>
          )
        })
      }
      return (
        <el-row
          type="flex"
          justify="space-between"
          align="middle"
          style="padding: 10px 0"
        >
          <ul class="tab-nav">
            {/*<el-checkbox style="margin-right:20px" indeterminate={this.isIndeterminate} v-model={this.checkAll} onChange={this.handleCheckAllChange}></el-checkbox>*/}
            {renderTabLi()}
          </ul>
        </el-row>
      )
    },
    /** 渲染订单列表 */
    renderOrderList() {
      const { orders } = this
      const renderHandle = () => {
        if (!Array.isArray(orders) || !orders.length) {
          return <el-empty description="没有订单哦~快去下单吧!" />
        }
        return orders.map(order => {
          return this.renderOrder(order)
        })
      }
      return (
        <div class="order-content">
          <el-checkbox-group v-model={this.checkedOrders} onChange={this.handleCheckedOrdersChange}>
            {renderHandle()}
          </el-checkbox-group>
        </div>
      )
    },
    /** 渲染单个订单 */
    renderOrder(order) {
      return (
        <div class="order-box" key={order.ID}>
          {this.renderOrderHeader(order)}
          {this.renderOrderBody(order)}
          {this.renderOrderFooter(order)}
        </div>
      )
    },
    /** 渲染订单头部 */
    renderOrderHeader(order) {
      const infoUrl = `/users/#/orderinfo/${order.ID}`
      const copyUrl = `/users/#/orderedit/${order.ID}/1`
      const editUrl = `/users/#/orderedit/${order.ID}/0`
      //console.log(order.InvoiceStatus==1||order.Status<=69);
      return (
        <el-row
          type="flex"
          justify="space-between"
          align="middle"
          class="bg-gray under-line pd-10"
        >
          <span>
            <el-checkbox class="order-title-item" label={order} key={order.ID} disabled={order.InvoiceStatus == 1 || order.Status <= 69}><span></span></el-checkbox>
            <span class="order-title-item">{order.CreateTime}</span>
            <a href={infoUrl} class="order-title-item order-no">{order.OrderNo}</a>

          </span>
          <div class="opt-box">
            <span>
              {order.InvoiceStatus === 1 && <strong class="text-success">【已申请开票】</strong>}
              {order.InvoiceStatus === 2 && <strong class="text-error">【已开票】</strong>}
            </span>
            <span>
              {order.IsPay === 1 && <strong class="text-success">【已支付】</strong>}
              {order.IsPay === 0 && <strong class="text-error">【未支付】</strong>}
              {order.IsPay === -1 && <strong class="text-danger">【已支付待确认】</strong>}
            </span>
            <span>
              <b class="order-stat">{order.StatusName}</b>
            </span>
            <el-divider direction="vertical" />
            <a href={infoUrl} class="under-line" size="mini">订单详情</a>
            <el-divider direction="vertical" />
            {order.SeckillCount == 0 &&  <a href={copyUrl} class="under-line" size="mini">复制订单</a> }
            {/* <a href={copyUrl} class="under-line" size="mini">复制订单</a>  */}
            <el-divider direction="vertical" />
            {(order.Status >= 0 && order.Status <= 50 && order.EStatus <= 43) && <a href={editUrl} class="under-line" size="mini">编辑订单</a>}
            {!(order.Status >= 0 && order.Status <= 50) && <a href="#" class="under-line disabled" size="mini">编辑订单</a>}

          </div>
        </el-row>
      )
    },
    /** 渲染订单主体 */
    renderOrderBody(order) {
      return (
        <el-row type="flex" justify="end" align="middle" class="under-line">
          <div style="flex: 1; padding: 10px">
            <el-row type="flex" justify="start" align="middle">
              {
                order.ServicePics.length &&
                <div class="img-box">
                  <a href={this.getGoodsInfoUrl(order)}>
                    <img src={this.getGoodsImg(order.ServicePics[0].url)} />
                  </a>

                </div>
              }
              <div class="goods-info">
                {order.IsUrgent === 1 && <b class="special-flag">加急</b>}
                {order.IsEnReport === 1 && <b class="special-flag">英文报告</b>}
                {' '}
                <a href={this.getGoodsInfoUrl(order)}>{order.ServeName}</a>
              </div>
            </el-row>
            <el-row type="flex" justify="start" align="middle" class="pd-10">
              {order.ProxyCustName && <div class="info-item label">
                <span>申请客户：</span>
                <b>{order.ProxyCustName}</b>
              </div>}
              {order.CQCNo && <div class="info-item label">
                <span>CQC申请编号：</span>
                <b>{order.CQCNo}</b>
              </div>}
              <div class="info-item label">
                <span>预计工作日：</span>
                <b>{order.Cycle}</b>
              </div>
            </el-row>
            {
              false && <el-row type="flex" justify="start" align="middle" class="pd-10">
                {this.renderDemoReport(order)}
                {this.renderOfficialReport(order)}
              </el-row>
            }
          </div>
          <div class="order-error-box">
            {order.ErrorMsg && <div class="error-item"><i class="bi bi-exclamation-diamond-fill" /><small>{order.ErrorMsg}</small></div>}
            {order.EStatusName && <div class="error-item"><i class="bi bi-chat-right-dots" /><small>{order.EStatusName}</small></div>}
          </div>
          <div class="primary-divider"></div>
          <div class="price-box">
            <el-row type="flex" justify="space-between" align="middle">
              <span class="item-price-label">订单总价：</span>
              <span class="item-price item-price-2">{order.TotalPrice}</span>
            </el-row>
            {false && <el-row type="flex" justify="space-between" align="middle">
              <span class="item-price-label">其他费用：</span>
              <span class="item-price item-price-2">{order.OtherPrice}</span>
            </el-row>}
            <el-row type="flex" justify="space-between" align="middle">
              <span class="item-price-label">优惠：</span>
              <span class="item-price item-price-2">{order.PriceAgioed}</span>
            </el-row>

            {
              order.PhaseAmt.toString() !== "0" && (
                <el-row type="flex" justify="space-between" align="middle">
                  <span class="item-price-label">修改差额：</span>
                  <span class="item-price item-price-2">{order.PhaseAmt}</span>
                </el-row>
              )
            }
            <el-row type="flex" justify="space-between" align="middle">
              <span class="item-price-label">应付金额：</span>
              <span class="item-price item-price-2">{order.OrderAmt}</span>
            </el-row>
            {order.ReceiveAmt > 0 && <el-row type="flex" justify="space-between" align="middle">
              <span class="item-price-label">已付金额：</span>
              <span class="item-price item-price-2">{order.ReceiveAmt}</span>
            </el-row>}
            {order.PayAmt > 0 && <el-row type="flex" justify="space-between" align="middle">
              <span class="item-price-label">待付金额：</span>
              <span class="item-price item-price-2">{order.PayAmt}</span>
            </el-row>}
          </div>
        </el-row>
      )
    },
    /** 渲染草稿报告 */
    renderDemoReport(order) {
      const { DemoReport } = order;
      if (Array.isArray(DemoReport) && DemoReport.length) {
        return <div class="info-item label">
          <span>草稿报告：</span>
          {this.renderReportList(DemoReport)}
        </div>
      }
      return null
    },
    /** 渲染正式报告 */
    renderOfficialReport(order) {
      const { OfficialReport } = order;
      if (Array.isArray(OfficialReport) && OfficialReport.length) {
        return <div class="info-item label">
          <span>正式报告：</span>
          {this.renderReportList(OfficialReport)}
        </div>
      }
      return null
    },
    /** 渲染报告文件列表 */
    renderReportList(files) {
      return files.map(f => {
        const { name, url } = f
        return <a href={url} target="blank" class="under-line">{name}</a>
      })
    },
    /** 渲染订单脚部 */
    renderOrderFooter(order) {
      const storeUrl = `/Shop/Index/${order.DeptID}`
      const showReportListBtn =
        (order.OfficialReport && order.OfficialReport.length) ||
        (order.DemoReport && order.DemoReport.length)
      return (
        <el-row
          type="flex"
          justify="space-between"
          align="middle"
          class="pdr under-line"
          style="min-height: 40px"
        >
          <div class="store-box">
            {order.ShopName && <strong>
              <svg t="1651758838759" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15323" width="18" height="18"><path d="M861.87008 409.6c0 42.3424-34.46784 76.8-76.8 76.8a76.02176 76.02176 0 0 1-51.0976-19.99872L716.8 450.93888l-17.17248 15.4624c-28.52864 25.8048-73.65632 25.8048-102.1952 0l-17.16224-15.4624-17.17248 15.4624c-28.52864 25.8048-73.6256 25.8048-102.22592 0l-17.14176-15.4624-17.13152 15.4624c-28.60032 25.8048-73.66656 25.8048-102.26688 0L307.2 450.93888l-17.13152 15.4624c-14.336 12.94336-32.47104 19.99872-51.13856 19.99872-42.33216 0-76.8-34.4576-76.8-76.8l76.8-307.2h546.14016l76.8 307.2zM819.2 853.34016V532.39808c-10.92608 3.072-22.23104 5.20192-34.12992 5.20192-24.23808 0-47.84128-7.00416-68.27008-20.06016-40.86784 26.13248-95.67232 26.13248-136.52992 0-40.86784 26.0608-95.67232 26.0608-136.54016 0-40.8576 26.13248-95.66208 26.13248-136.52992 0a126.75072 126.75072 0 0 1-68.27008 20.06016c-11.89888 0-23.20384-2.12992-34.12992-5.20192v320.94208H102.4V921.6h819.2v-68.25984H819.2z m-375.47008 0H307.2v-204.8h136.52992v204.8zM716.8 785.07008H546.12992V648.54016H716.8v136.52992z" p-id="15324" fill="#083090"></path></svg>
              <a href={storeUrl} class="order-title-item under-line">{order.ShopName}</a>
            </strong>}

            {order.ExpressNumber && <strong>
              <a class="order-title-item under-line">{order.ExpressCompany}</a>
              <a class="order-title-item under-line">{order.ExpressNumber}</a>
            </strong>}

            {order.QQ && <strong>
              <svg t="1651758666657" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12736" width="18" height="18"><path d="M866.991 707.772c0 0-25.341 69.55-71.877 132.071 0 0 83.05 28.439 76.137 102.196 0 0 2.709 82.331-177.613 76.685 0 0-126.817-9.898-164.88-63.85l-33.53 0c-38.018 54.006-164.834 63.85-164.834 63.85-180.431 5.7-177.556-76.685-177.556-76.685-7.025-73.756 76.081-102.196 76.081-102.196-46.475-62.519-71.875-132.071-71.875-132.071-112.759 183.141-101.477-25.567-101.477-25.567 21.141-123.495 109.949-204.384 109.949-204.384-12.677-112.157 33.805-132.078 33.805-132.078 9.68-346.979 306.473-340.887 312.675-340.722 6.249-0.163 302.931-6.256 312.72 340.723 0 0 46.538 19.866 33.812 132.078 0 0 88.751 80.89 109.886 204.384 0.055-0.001 11.285 208.707-101.421 25.566l0 0 0 0z" p-id="12737" fill="#083090"></path></svg>

              <a href={`http://wpa.qq.com/msgrd?v=3&uin=${order.QQ}&site=qq&menu=yes`} target="_blank" class="order-title-item under-line">{order.QQ}</a>
            </strong>}
          </div>
          <el-row type="flex" justify="start" align="middle">
            {(order.RefundStatus === 1) && this.renderRefundBtn(order)}
            {(order.RefundStatus === 0) && (order.InvoiceStatus === 0) && (order.InvoiceStatus > 59) && this.renderMakeInvoiceBtn(order)}
            {(order.RefundStatus === 0) && (order.Status === 80) && this.renderOrderEvaluateBtn(order)}
            {(order.RefundStatus === 0) && showReportListBtn && this.renderReportListBtn(order)}
            {(order.RefundStatus === 0) && (order.Status >= 0 && order.Status <= 19) && this.SignatureBtn(order)}
            {(order.RefundStatus === 0) && (order.Status >= 0 && order.Status <= 19) && this.GenerateXYSBtn(order)}
              {(order.RefundStatus === 0) && (order.Status >= 0 && order.Status <= 70) && this.ViewXYBtn(order)}
            {(order.RefundStatus === 0) && (order.Status >= 0 && order.Status <= 70) && this.renderOrderFilesBtn(order)}
            {(order.RefundStatus === 0) && (order.Status >= 0 && order.Status <= 60) && this.renderOrderSampleBtn(order)}
            {(order.RefundStatus === 0) && (order.PayAmt > 0 && order.Status >= 0) && this.renderPayBtn(order)}
            {(order.RefundStatus === 0) && (order.Status === 0) && this.renderSubmitOrderBtn(order)}
            {(order.RefundStatus === 0) && (order.Status >= 0 && order.Status < 40) && this.renderCancelOrderBtn(order)}
          </el-row>
        </el-row>
      )
    },
    /** 全选 */
    handleCheckAllChange(val) {
      this.checkedOrders = val ? this.orders : [];
      this.isIndeterminate = false;
      console.log(this.checkedOrders);
    },
    /** 多选订单 */
    handleCheckedOrdersChange(orders) {
      console.log(orders);
      let checkedCount = orders.length;
      this.checkAll = checkedCount === this.orders.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.orders.length;
    },
    /** 开票按钮 */
    renderMakeInvoiceBtn(order) {
      const onMakeInvoiceBtnClick = e => {
        e.stopPropagation()
        this.onOpenMakeInvoiceDialog([].concat(order))
      }
      return (
        <div
          class="success-btn small-btn"
          onClick={onMakeInvoiceBtnClick}
        >
          <span style="margin-left: 5px">开票</span>
        </div>)
    },
    /** 退款按钮 */
    renderRefundBtn(order) {
      const onRefundBtnClick = e => {
        e.stopPropagation()
        this.$prompt('确认申请退款吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '请输入退款理由',
          type: 'warning',
        }).then((remark) => {
          let result = {
            DeptID: order.DeptID,
            GoodsDeptID: order.GoodsDeptID,
            OrderID: order.ID,
            OrderNo: order.OrderNo,
            OrderName: order.ServeName,
            OrderAmt: order.OrderAmt,
            PayAmount: order.ReceiveAmt,
            Payment: 'Offline',
            Remark: remark.value
          }
          console.log(result)
          const postData = {
            ID: '',
            data: JSON.stringify(result)
          }
          OrderRefundEdit(postData).then(res => {
            console.log(res)
            if (!res.success) {
              return this.$message.error("申请退款失败：" + res.msg)
            }
            this.$message.success("申请退款成功!")
          })
        }).catch(() => { });
      }

      return (
        <div
          class="save-btn small-btn"
          onClick={onRefundBtnClick}
        >
          <span style="margin-left: 5px">退款</span>
        </div>)
    },
    /** 报告列表Btn */
    renderReportListBtn(order) {
      const onReportListBtnClick = e => {
        e.stopPropagation()
        this.onOpenOrderReportListDialog(order)
      }
      const btnText = order.Status === 61 ? "草稿报告待确认" : "报告列表";
      const btnClassName = order.Status === 61 ? "danger-btn small-btn" : "success-btn small-btn";
      return (
        <div
          class={btnClassName}
          onClick={onReportListBtnClick}
        >
          <span style="margin-left: 5px">{btnText}</span>
        </div>)
    },

    /** 订单评价Btn */
    renderOrderEvaluateBtn(order) {
      const onOrderEvaluateBtnClick = e => {
        e.stopPropagation()
        this.onOpenOrderEvaluateDialog(order)
      }
      return (
        <div
          class="save-btn small-btn"
          onClick={onOrderEvaluateBtnClick}
        >
          <span style="margin-left: 5px">订单评价</span>
        </div>)
    },
       /** 签名Btn */
    SignatureBtn(order) {
      const SignatureBtnClick = e => {
       window.open('https://ceulccc.com/qm.html?id='+order.ID+'');
      }
      return (
        <div
         class="user-btn small-btn"
          onClick={SignatureBtnClick}
        >
          <span style="margin-left: 5px">在线签名</span>
        </div>)
    },
       /** 生成协议Btn */
    GenerateXYSBtn(order) {
      const SignatureBtnClick = e => {
        var options={
          lock: true,
          text: '生成中，请稍候',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        };
        Loading.service(options);
          const postData = {
            ID: order.ID
          }
          GenerateXYS(postData).then(res => {
            let loadingInstance = Loading.service(options);
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              loadingInstance.close();
             });
            if (!res.success) {
              return this.$message.error(res.msg)
            }
            this.$message.success("生成成功!")
            this.handleGetList()
          })
      }
      return (
        <div
         class="user-btn small-btn"
          onClick={SignatureBtnClick} 
        >
          <span style="margin-left: 5px">生成协议书</span>
        </div>)
    },
     /** 查看协议Btn */
    ViewXYBtn(order) {
      const SignatureBtnClick = e => {
         if(!order.Xys){
         this.$message.error("协议书不存在，请先生成协议书！");
         }else{
           window.open('https://ceulccc.com'+order.Xys+'');
         }
      }
      return (
        <div
         class="user-btn small-btn"
          onClick={SignatureBtnClick}
        >
          <span style="margin-left: 5px">查看协议书</span>
        </div>)
    },
    /** 附件管理Btn */
    renderOrderFilesBtn(order) {
      const onOrderFilesBtnClick = e => {
        e.stopPropagation()
        this.onOpenOrderFilesDialog(order)
      }
      return (
        <div
          class="save-btn small-btn"
          onClick={onOrderFilesBtnClick}
        >
          <span style="margin-left: 5px">附件管理</span>
        </div>)
    },
    /** 录入样品Btn */
    renderOrderSampleBtn(order) {
      const onOrderSampleBtnClick = e => {
        e.stopPropagation()
        this.onOpenOrderSampleEditDialog(order)
      }
      return (
        <div
          class="save-btn small-btn"
          onClick={onOrderSampleBtnClick}
        >
          <span style="margin-left: 5px">录入样品</span>
        </div>)
    },
    /** 立即支付Btn */
    renderPayBtn(order) {
      const onPayBtnClick = e => {
        e.stopPropagation()
        this.onPayOrderAmount(order)
      }
      return (
        <div
          class="buy-btn small-btn"
          onClick={onPayBtnClick}
        >
          <span style="margin-left: 5px">立即支付</span>
        </div>)
    },
    /** 提交订单Btn */
    renderSubmitOrderBtn(order) {
      const onSubmitOrderBtnClick = e => {
        e.stopPropagation()
        this.onChangeOrderStatus(11, order.ID)
      }
      return (
        <div
          class="user-btn small-btn"
          onClick={onSubmitOrderBtnClick}
        >
          <span style="margin-left: 5px">提交订单</span>
        </div>)
    },
    /** 取消订单Btn */
    renderCancelOrderBtn(order) {
      const onCancelOrderBtnClick = e => {
         this.$prompt('确认取消订单吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
            e.stopPropagation()
             this.onChangeOrderStatus(-9, order.ID)
        }).catch(() => { });
     
      }
      return (
        <div
          class="danger-btn small-btn"
          onClick={onCancelOrderBtnClick}
        >
          <span style="margin-left: 5px">取消订单</span>
        </div>)
    },
    /** 渲染分布器 */
    renderPagination() {
      const { pagination } = this
      return <el-row type="flex" justify="end" align="middle">
        <el-pagination
          on-size-change={this.onPaginationSizeChange}
          on-current-change={this.onPaginationCurrentChange}
          on-current-page={pagination.currentPage}
          page-sizes={[20, 40, 60, 100, 500]}
          page-size={pagination.pageSize}
          layout="total, prev, pager, next"
          total={pagination.total}
        >
        </el-pagination>
      </el-row>
    },
    /** 每页显示数量改变事件 */
    onPaginationSizeChange(val) {
      this.pagination.pageSize = val;
      this.handleGetList();
    },
    /** 当前页改变事件 */
    onPaginationCurrentChange(val) {
      this.pagination.currentPage = val;
      this.handleGetList();
    },
    // --打开报告列表窗口
    onOpenOrderReportListDialog(order) {
      const DemoReport = order.DemoReport || []
      const OfficialReport = order.OfficialReport || []
      const compShow = {
        compPath: require('@/views/Order/components/ReportList.vue'),
        compProps: {
          demolist: [...DemoReport],
          officiallist: [...OfficialReport],
          id: order.ID,
          hidebtn: order.Status > 61
        },
        key: 'compShow'
      }
      const dlgOptions = {
        dialog: {
          title: '报告列表',
          width: '720px'
        },
        okBtn: {
          show: false,
          text: '确定'
        },
        cancleBtn: {
          show: false,
          text: '关闭'
        }
      }
      return this.$commdlg().Options(dlgOptions).Component(compShow).Open((dlg, close) => {
        this.handleGetList();
        close();
      }, (_, close) => {
        this.handleGetList();
        close();
      })
    },
    // --打开录入样品窗口
    async onOpenOrderSampleEditDialog(order) {
      const lab = await RceivingSampleLabView({ ID: order.LabID })
      if (!lab.success) { return this.$message.error('接样实验室信息获取失败：' + res.msg) }
      const compShow = {
        compPath: require('@/views/Order/components/ListShow.vue'),
        compProps: {
          list: [
            { prop: '订单编号', value: order.OrderNo },
            { prop: '机构名称', value: order.InstitutionName },
            { prop: '接样实验室', value: lab.data.Name },
            { prop: '寄样地址', value: lab.data.Address },
            { prop: '联系人', value: lab.data.Linker },
            { prop: '联系人电话', value: lab.data.LinkTel },
          ]
        },
        key: 'compShow'
      }
      const OrderSendSample = await OrderSendSampleView({ OrderID: order.ID })
      var OrderSendSampleID = !!OrderSendSample.data ? OrderSendSample.data.ID : null;
      const compEdit = {
          compPath: require('@/views/Order/components/SampleEditForm.vue'),
          compRef: 'orderSampleEditDlg',
          key: 'compEdit',
          compProps: {
            obj1: OrderSendSample.data
          },
        }

      const dlgOptions = {
        dialog: {
          title: '订单样品编辑',
          width: '1080px'
        },
        okBtn: {
          text: '提  交'
        },
        cancleBtn: {
          show: false,
          text: '取  消'
        }
      }
      return this.$commdlg().Options(dlgOptions).Component(compShow).Component(compEdit).Open((dlg, close) => {
        let f = null
        if (Array.isArray(dlg)) {
          f = (dlg.find(x => x.refKey === 'orderSampleEditDlg') || {}).refComp
        } else {
          f = dlg.$refs.orderSampleEditDlg[0]
        }

        if (f) {
          let data = f.GetData()
          if (data) {
            data = {
              ID: OrderSendSampleID,
              OrderID: order.ID,
              OrderNo: order.OrderNo,
              GoodsDeptID: order.GoodsDeptID,
              LabID: lab.data.ID,
              LabName: lab.data.Name,
              LabAddress: lab.data.Address,
              LabLinker: lab.data.Linker,
              LabLinkTel: lab.data.LinkTel,
              ...data
            }
            const postData = {
              ID: OrderSendSampleID,
              Name: 'OrderSendSample',
              data: JSON.stringify(data)
            }
            if (OrderSendSampleID) {
              Edit(postData).then(res => {
                if (!res.success) {
                  return this.$message.error("样品信息修改失败：" + res.msg)
                }
                this.$message.success("样品信息添加成功")
                close()
              })
            } else {
              Add(postData).then(res => {
                if (!res.success) {
                  return this.$message.error("样品信息添加失败：" + res.msg)
                }
                this.$message.success("样品信息添加成功")
                close()
              })
            }

          }
        }
      })
    },
    // --打开订单评价窗口
    onOpenOrderEvaluateDialog(order) {
      const compEdit = {
        compPath: require('@/views/Order/components/OrderEvaluate.vue'),
        compRef: 'OrderEvaluateDlg',
        key: 'compEdit'
      }
      const dlgOptions = {
        dialog: {
          title: '订单评价',
          width: '800px'
        },
        okBtn: {
          text: '提  交'
        },
        cancleBtn: {
          show: false,
          text: '取  消'
        }
      }
      return this.$commdlg().Options(dlgOptions).Component(compEdit).Open((dlg, close) => {
        console.log('dlg', dlg)
        let f = null;
        if (Array.isArray(dlg)) {
          f = dlg.find(x => x.refKey === 'OrderEvaluateDlg').refComp
        } else {
          f = dlg.$refs.OrderEvaluateDlg[0]
        }

        if (f) {
          let data = f.GetData()
          if (data) {
            data = {
              OrderID: order.ID,
              ...data
            }
            const postData = {
              ID: order.ID,
              data: JSON.stringify(data)
            }
            SubmitOrderEvaluate(postData).then(res => {
              if (!res.success) {
                return this.$message.error("订单评价提交失败：" + res.msg)
              }
              this.$message.success("订单评价提交成功")
              close()
              this.handleGetList()
            })
          }
        }
      })
    },
    // --打开附件管理窗口
    onOpenOrderFilesDialog(order) {
      this.currentOrder = Object.assign({}, order)
      const files = this.currentOrder.OrderFile && Array.isArray(this.currentOrder.OrderFile) ? [...this.currentOrder.OrderFile] : []
      const GirConstructor = Vue.extend(OrderFiles);
      const nodeObj = new GirConstructor();
      nodeObj.$mount(document.createElement("div"));
      document.body.appendChild(nodeObj.$el);
      nodeObj.Options({ files, max: 24, acceptFileTypes: ['PDF', 'DOC', 'DOCX', 'RAR', 'ZIP', '7Z', 'XLS', 'XLSX', 'PPT', 'PPTX'], readOnly: false});
      nodeObj.Open((files, close) => this.handlePostReportFiles(files, order, close),this.currentOrder);
    },
    onPayOrderAmount(order) {
      return this.$router.push(`/orderpay/${order.ID}`)
    },
    handlePostOrderPay(obj, order, close) {
      SubmitOrderPay({ ID: order.ID, Payment: obj.Payment, PayAmount: obj.PayAmount, PayFile: JSON.stringify(obj.PayFile) }).then(res => {
        if (!res.success) {
          return this.$message.error('订单支付提交失败：' + res.msg)
        }
        this.$message.success('订单支付提交成功！')
        this.$nextTick(() => {
          this.handleGetList()
          if (typeof close === 'function') {
            close();
          }
        })

      })
    },
    /** 提交保存订单附件 */
    handlePostReportFiles(files, order, close) {
      SaveOrderFile({ OrderID: order.ID, ID: order.ID, OrderFile: JSON.stringify(files) }).then(res => {
        if (!res.success) {
          return this.$message.error('保存订单附件失败：' + res.msg)
        }
        this.$message.success('订单附件保存成功！')
        this.handleGetList()
        if (typeof close === 'function') {
          close();
        }
      })
    },
    // --获取字典
    GetItemDetailList(callback) {
      GetItemDetailList({ ItemCode: 'OrderStatus' }).then(res => {
        console.log(res)
        if (!res.success) {
          return this.$message.error("订单状态数据获取失败：" + res.msg)
        }
        this.orderStatus = [{ name: '?', label: '全部订单' }, ...res.data.map(x => ({
          name: x.ItemValue,
          label: x.ItemName
        }))]
        callback()
      })
    },
    InitialData() {
      this.handleGetList()
    },
    /** 改变订单状态 */
    onChangeOrderStatus(Status, ID) {
      SaveOrderStatus({ Status, ID }).then(res => {
        if (!res.success) {
          return this.$message.error('操作失败：' + res.msg)
        }
        this.$message.success('操作成功!')
        this.handleGetList()
      })
    },
    getGoodsImg(url) {
      return url.toUpperCase().startsWith('HTTP') ? url : process.env.VUE_APP_BASE_API == '/' ? url : process.env.VUE_APP_BASE_API + url;
    },
    getGoodsInfoUrl(o) {
      return `/Service/Detail/${o.GoodsAgentID}?l=${o.LabID}&a=${o.GoodsAttributeID}`
    },
    onSearching() {
      this.$message.success("Searching Finished!")
    },
    /** 获取订单状态值 */
    getOrderStautsName(Status) {
      console.log(" --- getOrderStautsName ---", Status)
      const s = this.orderStatus.filter(x => x.name && x.name !== '?').find(x => {
        const n = x.name.substr(1)
        const [f, v] = n.split('&')
        const f_v = f.split('=')[1]
        const v_v = v.split('=')[1]
        if (f_v === 'Status') {
          if (v_v.includes(',')) {
            const [v1, v2] = v_v.split(',')
            return Status >= v1 && Status <= v2
          }
          if (v_v.includes('~')) {
            const [v1, v2] = v_v.split('~')
            return Status >= v1 && Status <= v2
          }
          return Status.toString() === v_v.toString()
        }
        return false
      })
      return s ? s.label : '获取状态异常'
    },
    /** 解析当前请求条件 */
    analysisGetListParam() {
      // ?f=Status&v=0 ?f=Status&v=10~20 ?f=PayAmt&v=!0
      const { query } = this.$route
      const { f, v } = query
      if (!f || !v) {
        this.activeName = '?'
        return []
      }

      this.activeName = `?f=${f}&v=${v}`
      if (v.includes('~')) {
        const [v1, v2] = v.split('~')
        return [{
          SqlField: f,
          pattern: 'greater',
          value: v1
        },
        {
          SqlField: f,
          pattern: 'less',
          value: v2
        }]
      } else if (v.includes(',')) {
        const [v1, v2] = v.split(',')
        return [{
          SqlField: f,
          pattern: 'greater',
          value: v1
        },
        {
          SqlField: f,
          pattern: 'less',
          value: v2
        }]
      } else if (v.startsWith('g')) {
        return [{
          SqlField: f,
          pattern: 'greater',
          value: v.substr(1)
        }, {
          SqlField: 'Status',
          pattern: 'greater',
          value: -9
        }
        ]
      } else if (v.startsWith('l')) {
        return [{
          SqlField: f,
          pattern: 'less',
          value: v.substr(1)
        }]
      } else {
        return [{
          SqlField: f,
          pattern: 'equal',
          value: v
        }]
      }
    },
    onOrderStatusTabClick(orderStatusName, href) {
      console.log(' -- onOrderStatusTabClick --', orderStatusName, href)
      this.handleGetList()
    },
    /** 获取列表数据 */
    handleGetList() {
      const params = this.analysisGetListParam()
      if (this.params.orderNo) {
        params.push({
          SqlField: "OrderNo",
          pattern: 'like',
          value: this.params.orderNo
        })
      }
      if (this.params.proxyCustName) {
        params.push({
          SqlField: "ProxyCustName",
          pattern: 'like',
          value: this.params.proxyCustName
        })
      }
      if (this.params.applyNo) {
        params.push({
          SqlField: "CQCNo",
          pattern: 'like',
          value: this.params.applyNo
        })
      }
      const queryParam = {
        Name: 'OrderWeb',
        searchEntity: JSON.stringify(params),
        currentPage: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        orderField: 'CreateTime',
        orderType: 'descend'
      }
      GetList(queryParam).then(res => {
        if (!res.success) {
          return this.$message.error('订单数据获取失败：' + res.msg)
        }
        console.log(res)
        this.orders = [...res.data.rows.map(x => {
          x.ServicePics = x.ServicePics || []
          return x
        })]
        this.pagination.currentPage = res.data.currentPage;
        this.pagination.pageSize = res.data.pageSize;
        this.pagination.total = res.data.total;
      })
    }
  }
}
</script>
<style lang="scss">
.no-header-underline {
  .el-card__header {
    padding: 18px 20px;
    border-bottom: 0px solid #ebeef5 !important;
    box-sizing: border-box;
  }
}
</style>
<style lang="scss" scoped>
.tab-nav {
  display: flex;
  align-items: center;
  box-sizing: border-box;

  .nav-row-item {
    display: inline-block;
    padding: 5px 20px;

    .a-normal-tab {
      color: #333;
      display: inline-block;
      border-bottom: 2px solid #fff;
      cursor: pointer;
      transition: all 0.5s linear;
      padding: 5px;

      &:hover {
        color: #083090;
      }

      &.active {
        font-weight: 700;
        color: #083090;
        border-bottom: 2px solid #083090;
      }
    }
  }
}

.order-content {
  padding: 10px 0;
  box-sizing: border-box;

  .order-box {
    font-size: 12px !important;
    border: 1px solid #eaeaea;
    border-bottom: none;
    box-sizing: border-box;
    margin-bottom: 15px;

    &:last-child {
      border-bottom: 0px solid #eaeaea;
    }

    .store-box {
      box-sizing: border-box;
      display: inline-flex;
      align-items: center;

      strong {
        line-height: 18px;
        display: inline-flex;
        align-items: center;
        margin-right: 15px;
        margin-left: 3px;

        svg {
          margin-right: 2px;
        }

        a {
          font-size: 14px;
          color: #6c6c6c;
          font-weight: 500 !important;
        }
      }
    }

    .order-title-item {
      line-height: 20px;
      margin-right: 10px;
      color: #666;

      &.order-no {
        color: #000;
        font-weight: 600;
        font-size: 14px;

        &::before {
          content: "订单号:";
          font-size: 12px;
          color: #666;
        }
      }
    }

    .order-stat {
      font-size: 12px;
      color: #083090;
      font-weight: 700;

      &::before {
        content: "【";
      }

      &::after {
        content: "】";
      }
    }

    .order-opt-item {
      width: 28px;
      height: 28px;
      border: 1px solid #e6e6e6;
      border-radius: 50%;
      color: #083090;
      font-weight: 600;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      transition: all 0.3s linear;

      &:hover {
        color: #fff;
        background: #c10015;
      }
    }

    .info-item {
      color: #6c6c6c !important;
      margin-right: 10px;

      b {
        font-weight: 600;
        color: #000;
      }

      &.label {
        &::before {
          content: "●";
          margin-right: 5px;
        }
      }
    }

    .goods-info {
      padding-left: 10px;

      a {
        font-size: 15px !important;
        color: #000 !important;
      }
    }

    .img-box {
      width: 84px;
      height: 84px;
      box-sizing: border-box;
      background: #f5f5f5;
      border-radius: 2px;
      margin: 5px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        max-height: 100%;
        max-width: 100%;
      }
    }

    .primary-divider {
      width: 1px;
      min-height: 100px;
      margin: 0 10px;
      height: 100%;
      background: linear-gradient(#ffffff, #083090, #ffffff);
    }

    .order-error-box {
      width: 120px;

      .error-item {
        color: #ca4300;
        font-size: 14px;
        padding: 5px;
        font-weight: 600;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        border: 1px solid #f0f0f0;
        margin: 3px auto;

        i {
          font-size: 16px;
        }

        span {
          flex: 1;
          padding-left: 10px;
        }
      }
    }

    .price-box {
      width: 180px;
      padding: 10px;
      font-size: 12px;
      color: #666;

      .item-price-label {
        text-align: right;
        width: 75px;
      }

      .item-price {
        flex: 1;
        display: inline-flex;
        color: #ca4300;
        font-size: 19px;
        font-weight: 700;
        width: 60px;
        flex-direction: column;
        justify-content: center;

        &::before {
          color: #ca4300;
          content: "￥";
          font-size: 11px;
        }

        &.item-price-2 {
          margin-left: 10px;
          display: inline-block;
          color: #ca4300;
          font-size: 14px;
          font-weight: 700;
          width: 60px;
        }
      }
    }
  }
}
</style>